/**
 * Строка даты-времени из API без суффикса зоны (частый контракт): трактуем как UTC.
 * Иначе `Date` в JS читает её как локальное время → сдвиг на часовой пояс.
 *
 * Строки формы `YYYY-MM-DDTHH:mm` сюда не передаём — для них используйте `new Date(...)`.
 */
const ISO_NAIVE_UTC = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/

const hasExplicitTimeZoneSuffix = (s: string): boolean =>
  /Z$/i.test(s) || /[+\-]\d{2}:\d{2}$/.test(s) || /[+\-]\d{4}$/.test(s)

/** Строка из API без зоны — будет разобрана как UTC в `parseEventApiInstant`. */
const isEventApiNaiveUtcString = (value: string): boolean => {
  const raw = value.trim()
  if (!raw) return false
  return ISO_NAIVE_UTC.test(raw) && !hasExplicitTimeZoneSuffix(raw)
}

export const parseEventApiInstant = (value: string): Date => {
  const raw = value.trim()
  if (!raw) return new Date(NaN)
  return isEventApiNaiveUtcString(raw) ? new Date(`${raw}Z`) : new Date(raw)
}
